import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_RJA } from '@/config/constants'
import PropTypesHelpers from '@/utils/propTypesHelpers'

const MenuItemContainer = ({
  children,
  href,
  title,
  onClick,
  className,
  htmlTag: Tag = 'a',
  target,
  rel
}) => {
  const isRJA = NAV_BRAND.portal_type === PORTAL_TYPE_RJA
  const [activeLink, setActiveLink] = useState(false)
  const history = useHistory()

  useEffect(() => {
    if (!isRJA || !href) {
      return
    }
    const locationListener = ({ pathname }) => {
      setActiveLink(pathname === href.split('?')[0])
    }
    locationListener(window.location)
    return history.listen(locationListener)
  }, [history, href, isRJA])

  return (
    <li
      className={classnames('nav-item', { 'active-link qa-active-link': activeLink }, className)}
      title={title}
    >
      <Tag
        className='nav-link'
        href={href}
        onClick={onClick}
        target={target}
        rel={rel}
      >
        {children}
      </Tag>
    </li>
  )
}

MenuItemContainer.propTypes = {
  children: PropTypesHelpers.children,
  className: PropTypesHelpers.classnames,
  href: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  htmlTag: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string
}

export default MenuItemContainer
